var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowLeftFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 21C12.05 21 11.861 20.9307 11.72 20.8044L1.22 11.4711C1.15 11.4089 1.095 11.336 1.057 11.2533C1.054 11.2462 1.05 11.2382 1.047 11.2302C1.016 11.1547 0.999998 11.0782 0.999998 11C0.999998 10.9209 1.016 10.8436 1.048 10.768C1.05 10.7618 1.053 10.7556 1.056 10.7493C1.096 10.6631 1.151 10.5902 1.222 10.528L11.72 1.19556C11.862 1.06934 12.05 1 12.25 1C12.45 1 12.639 1.06934 12.78 1.19556C12.922 1.32089 13 1.48889 13 1.66667C13 1.84445 12.922 2.01245 12.78 2.13778L3.56 10.3333L24.25 10.3333C24.664 10.3333 25 10.632 25 11C25 11.368 24.664 11.6667 24.25 11.6667L3.561 11.6667L12.781 19.8622C13.073 20.1218 13.073 20.5449 12.781 20.8053C12.639 20.9307 12.45 21 12.25 21Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeftFull);
export default __webpack_public_path__ + "static/media/icon-arrow-left-full.caaa76867bfdfb2742678ceecf6b2d42.svg";
export { ForwardRef as ReactComponent };